import { Component, input, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { EntityLicense } from '../../../../../domain/model/profile/entityLicense';
import { EnrollmentRentalPropertyLicense } from '../../../../../domain/model/enrollment/enrollmentRentalPropertyLicense';
import { atLeastOneRequiredValidator } from '../../../../../shared/utils/atLeastOneRequiredValidator';

@Component({
  selector: "app-entitylicensestep",

  templateUrl: "./entitylicensestep.component.html",
  styleUrl: "./entitylicensestep.component.css",
})
export class EntitylicensestepComponent implements OnChanges {
  constructor(private fb: FormBuilder) {}
 
  @Input() entityRentalPropertyLicense!: FormGroup;
  @Input() entityLicense!: EntityLicense;
  @Input() hidePrimaryContactInfo: boolean = false;
  ngOnInit() {
    this.entityRentalPropertyLicense.get("departmentOfBusiness")?.valueChanges.subscribe(() => {
      this.entityRentalPropertyLicense.get("departmentOfBusiness")?.markAsTouched();
    });
    this.entityRentalPropertyLicense.get("stateCertificateHasBeenApplied")?.valueChanges.subscribe((value) => {
      if (
        value &&
        this.entityRentalPropertyLicense.get("taxCertificateNumber")?.enabled &&
        this.entityRentalPropertyLicense.get("reasonWhy")?.enabled
      ) {
        if (this.entityRentalPropertyLicense.get("taxCertificateNumber")?.value) {
          this.entityRentalPropertyLicense.get("taxCertificateNumber")?.setValue("");
        }
        if (this.entityRentalPropertyLicense.get("reasonWhy")?.value) {
          this.entityRentalPropertyLicense.get("reasonWhy")?.setValue("");
        }
        this.entityRentalPropertyLicense.get("taxCertificateNumber")?.disable();
        this.entityRentalPropertyLicense.get("reasonWhy")?.disable();
      } else if (!value && this.entityRentalPropertyLicense.get("taxCertificateNumber")?.disabled) {
        this.entityRentalPropertyLicense.get("taxCertificateNumber")?.enable();
      }
    });
    this.entityRentalPropertyLicense.get("reasonWhy")?.valueChanges.subscribe((value) => { 
      if (
        value &&
        this.entityRentalPropertyLicense.get("taxCertificateNumber")?.enabled &&
        this.entityRentalPropertyLicense.get("stateCertificateHasBeenApplied")?.enabled
      ) {
        this.entityRentalPropertyLicense.get("stateCertificateHasBeenApplied")?.disable();
        this.entityRentalPropertyLicense.get("taxCertificateNumber")?.disable();
      }
      else if (
        !value &&
        (this.entityRentalPropertyLicense.get("stateCertificateHasBeenApplied")?.disabled ||
          this.entityRentalPropertyLicense.get("taxCertificateNumber")?.disabled) &&
        this.entityRentalPropertyLicense.get("reasonWhy")?.enabled
      ) {
        this.entityRentalPropertyLicense.get("stateCertificateHasBeenApplied")?.enable();
        this.entityRentalPropertyLicense.get("taxCertificateNumber")?.enable();
      }

      
    });
    this.entityRentalPropertyLicense.get("taxCertificateNumber")?.valueChanges.subscribe((value) => {
      this.entityRentalPropertyLicense.get("taxCertificateNumber")?.markAsTouched();
      value = value.replace(/[^0-9\-]/g, "");

      if (
        value &&
        (this.entityRentalPropertyLicense.get("reasonWhy")?.enabled ||
          this.entityRentalPropertyLicense.get("stateCertificateHasBeenApplied")?.enabled)
      ) {
        this.entityRentalPropertyLicense.get("reasonWhy")?.disable();
        this.entityRentalPropertyLicense.get("stateCertificateHasBeenApplied")?.disable();
        this.entityRentalPropertyLicense.get("reasonWhy")?.setValue("");
      } else if (!value
        && (this.entityRentalPropertyLicense.get("reasonWhy")?.disabled || this.entityRentalPropertyLicense.get("stateCertificateHasBeenApplied")?.disabled)
        && this.entityRentalPropertyLicense.get("taxCertificateNumber")?.enabled) {
        this.entityRentalPropertyLicense.get("stateCertificateHasBeenApplied")?.enable();
        this.entityRentalPropertyLicense.get("reasonWhy")?.enable();
      }
  
    });
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (this.entityLicense !=null){

      this.buildForm(this.entityLicense);
    }
  }
  private buildForm(data: EntityLicense | undefined): void {  
    this.entityRentalPropertyLicense = this.fb.group({
      departmentOfBusiness: new FormControl(data?.regulationLicenseNumber, 
        [Validators.pattern(/^[a-zA-Z1-9][a-zA-Z0-9]*$/)]),
        cityOfRegistration : new FormControl(data?.certicateOfRegistration),
        taxCertificateNumber: new FormControl(data?.taxCertificateNumber),
        stateCertificateHasBeenApplied: new FormControl(data?.stateCertificateHasBeenApplied),
        localBusinessTaxReceipt: new FormControl(data?.taxReceipt),
        reasonWhy:new FormControl(data?.reasonWhy),

    }, { validators: atLeastOneRequiredValidator(["reasonWhy", "stateCertificateHasBeenApplied", "taxCertificateNumber"]) })
  }
}
